var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({staticClass:"wac-cms-image",attrs:{"src":_vm.url,"alt":_vm.title,"url":null},on:{"click":_vm.onClick}},'img',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }